import { isPresent } from 'ts-is-present';

import { userInfoSchema } from '~/schemas/user_info_schema';

import type { UserInfo } from '~/schemas/user_info_schema';

/** GetProfile のレスポンスの me */
export type Me = Awaited<ReturnType<typeof GqlGetProfile>>['me'];

/**
 * GetProfile のレスポンスを UserInfo に変換する
 *
 * @remarks
 * 同じ変換が各画面に重複していたため 1 箇所にまとめている。
 * 取得自体は画面によって共有（{@link useProfile}）と個別取得が混在するが、
 * 変換結果は常に同じ形になるようにする。
 *
 * @throws スキーマに適合しない場合は ZodError
 */
export const parseUserInfo = (me: NonNullable<Me>): UserInfo =>
  userInfoSchema.parse({
    ...me,
    teacherProfile: {
      ...me.teacherProfile,
      subjectAreas:
        me.teacherProfile?.subjectAreas?.edges
          .filter(isPresent)
          .map((edge) => edge.node)
          .filter(isPresent)
          .map((area) => ({
            ...area,
            id: area.id,
            name: area.name,
          })) ?? [],
    },
    teacherAgents: me.teacherAgents?.edges
      .filter(isPresent)
      .map((edge) => edge.node)
      .filter(isPresent),
  });
